import { render, staticRenderFns } from "./FaturamentoModal.vue?vue&type=template&id=8c157fdc&scoped=true"
import script from "./FaturamentoModal.vue?vue&type=script&lang=js"
export * from "./FaturamentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c157fdc",
  null
  
)

export default component.exports